import { BlotterType } from 'models/blotters/BlotterType';
import { IBlotterItem } from 'models/IBlotterItem';
import type { ApiError } from 'utils/http/apiErrorHelper';

export interface TradeCancellation {
  status: TradeCancellationStatus;
  blotterItem: IBlotterItem;

  blotterType: BlotterType;
  error?: ApiError;
}
export type TradeCancellationStatus = 'INIT' | 'IN_PROGRESS' | 'SUCCESS' | 'FAILED' | 'REJECTED';

export type TradeCancellationsState = Readonly<Record<string, TradeCancellation>>;

export const initialTradeCancellationsState: TradeCancellationsState = {};
